import React from 'react';

import { EButtonKitType } from '@components/common/ButtonKit/enum';
import { ActionBaseButton } from '@components/common/ButtonKit/styled';
import { IButtonKit } from '@components/common/ButtonKit/typed';

const ButtonKit: React.FC<IButtonKit> = ({
  disabled,
  prefix,
  suffix,
  kitType = 'default',
  color,
  borderColor,
  backgroundColor,
  borderRadius,
  style,
  hoverStyle,
  children,
  ...rest
}) => {
  const buttonProps: { [key: string]: IButtonKit } = {
    [EButtonKitType.DEFAULT]: {
      backgroundColor: `${backgroundColor ? backgroundColor : '#fff'}`,
      borderColor: `${borderColor ? borderColor : '#686868'}`,
      color: `${color ? color : '#494949'}`,
      borderRadius: `${borderRadius ? borderRadius : '4px'}`,
      style: style,
      hoverStyle: hoverStyle,
    },
    [EButtonKitType.HOVER_PRIMARY]: {
      backgroundColor: `${backgroundColor ? backgroundColor : 'transparent'}`,
      borderColor: `${borderColor ? borderColor : 'transparent'}`,
      color: `${color ? color : '#0046FF'}`,
      borderRadius: `${borderRadius ? borderRadius : '4px'}`,
      style: style
        ? style
        : {
            gap: '6px',
          },
      hoverStyle: hoverStyle
        ? hoverStyle
        : {
            borderColor: '#0046FF',
            borderRadius: '2px',
          },
    },
    [EButtonKitType.PRIMARY]: {
      backgroundColor: `${backgroundColor ? backgroundColor : '#fff'}`,
      borderColor: `${borderColor ? borderColor : '#0046FF'}`,
      color: `${color ? color : '#0046FF'}`,
      borderRadius: `${borderRadius ? borderRadius : '4px'}`,
      style: style,
      hoverStyle: hoverStyle,
    },
    [EButtonKitType.PRIMARY_HIGHLIGHT]: {
      backgroundColor: `${backgroundColor ? backgroundColor : '#0046FF'}`,
      borderColor: `${borderColor ? borderColor : '#0046FF'}`,
      color: `${color ? color : '#fff'}`,
      borderRadius: borderRadius,
      style: style,
      hoverStyle: hoverStyle,
    },
    [EButtonKitType.DANGER]: {
      backgroundColor: `${backgroundColor ? backgroundColor : '#fff'}`,
      borderColor: `${borderColor ? borderColor : '#D0021B'}`,
      color: `${color ? color : '#D0021B'}`,
      borderRadius: `${borderRadius ? borderRadius : '4px'}`,
      style: style,
      hoverStyle: hoverStyle,
    },
    [EButtonKitType.DANGER_HIGHLIGHT]: {
      backgroundColor: `${backgroundColor ? backgroundColor : '#fc5555'}`,
      borderColor: `${borderColor ? borderColor : '#ff4d4f'}`,
      color: `${color ? color : '#fff'}`,
      borderRadius: borderRadius,
      style: style,
      hoverStyle: hoverStyle,
    },
  };

  const {
    backgroundColor: btn_backgroundColor,
    borderColor: btn_borderColor,
    color: btn_color,
    borderRadius: btn_borderRadius,
    style: btn_style,
    hoverStyle: btn_hoverStyle,
  } = buttonProps[kitType];

  return (
    <ActionBaseButton
      disabled={disabled}
      backgroundcolor={btn_backgroundColor}
      bordercolor={btn_borderColor}
      color={btn_color}
      borderradius={btn_borderRadius}
      style={btn_style}
      hoverstyle={btn_hoverStyle}
      {...rest}
    >
      {prefix}
      {children}
      {suffix}
    </ActionBaseButton>
  );
};

export default ButtonKit;
